import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, Validators, ReactiveFormsModule, FormsModule} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Printer } from 'src/app/domain/printer/printer';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export interface PrinterType {
  prefix: string;
  type: string;
}

@Component({
  selector: 'app-add-printer-dialog',
  templateUrl: './add-printer-dialog.component.html',
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule
  ],
  styleUrls: ['./add-printer-dialog.component.css']
})
export class AddPrinterDialogComponent implements OnInit {

  isPrinterTypeSelected = false;

  printerTypes: PrinterType[] = [
    { prefix: 'zpl-', type: 'ZPL' },
    { prefix: 'pdf-', type: 'PDF' }
  ];

  // Regex Patterns
  noSpecialCharsRegexPattern = '^[a-zA-Z0-9]+[\-]+[a-zA-Z0-9]+[\-]*[\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]*?$';
  hostnameRegexPattern = '^[a-zA-Z0-9.-]*$';

  // FormControls
  printerTypeValidator: FormControl<string | null>;
  noSpecialCharsValidatorName: FormControl<string | null>;
  noSpecialCharsValidatorConnection: FormControl<string | null>;

  constructor(
    public dialogRef: MatDialogRef<AddPrinterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Printer) {
  }

  ngOnInit(): void {
    // Initialize FormControls in ngOnInit to avoid undefined errors
    this.printerTypeValidator = new FormControl('', [
      Validators.nullValidator
    ]);

    this.noSpecialCharsValidatorName = new FormControl(this.data?.name, [
      Validators.required,
      Validators.pattern(this.noSpecialCharsRegexPattern)
    ]);

    this.noSpecialCharsValidatorConnection = new FormControl(this.data?.deviceURI, [
      Validators.required,
      Validators.pattern(this.hostnameRegexPattern)
    ]);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onPrinterTypeChange(printerType: string) {
    // Update the printer name when the type is selected
    // if (this.data?.name) {
    //   this.data.name = printerType.prefix + this.data.name;
    // } else {
    //   this.data.name = printerType.prefix;
    // }
    console.log('PRINTER-TYPE CHANGED');
    this.data.name = printerType;
    // Ensure the FormControl is updated as well
    this.noSpecialCharsValidatorName.setValue(this.data.name);
    this.isPrinterTypeSelected = true;
  }
}
